// extracted by mini-css-extract-plugin
export var colorBase = "qBYifKSZb6eCiYkU0F05";
export var colorDisabled = "TjIK_8uKR0qGiJrTWKhi";
export var colorInverted = "d_eTq4J1rACqWSA5hRXO";
export var colorNegative = "KMBQkYaSpRjDJaYE9VGx";
export var colorPositive = "X_SYCb1vzTC1oBc9sabQ";
export var colorSubdued = "oWSDwkrHkLpaKwqwzDPj";
export var colorSubtle = "mI5Fx5mpIT9AOYfdjnlE";
export var colorUrgencyHigh = "nceKuAhTp5p09LO22XmL";
export var colorUrgencyMedium = "iNifm2wz3vXsS_sS3CjS";
export var colorWarning = "qn4f9RzK7IPMz4qvDESw";
export var colorWhite = "nw2Odvi2_tIa_fr0EPdI";